import InfoLabel from "./InfoLabel";
import classes from "../../styles/InfoLabel.module.css";
import { useAppSelector, useTexts, useConfig } from "../../hooks";
import { doTranslation, numberToReadableStr } from "../../utils";

const EngineInfo: React.FC<{ visible: boolean }> = ({ visible }) => {
  const { rtp } = useAppSelector((state) => state.details);
  const { maxWin } = useConfig();
  const { common } = useTexts();

  if (!visible || !maxWin || maxWin.value <= 0) return <div></div>;

  return (
    <InfoLabel shape="rectangle" className={classes.engine} direction="left">
      <span className={classes.key}>
        {doTranslation("maxwin", {}, common)}:
      </span>
      <span className={classes.value}>
        x{maxWin.value} (1:{numberToReadableStr(maxWin.chance, common)})
      </span>
      <span className={classes.separator}>|</span>
      <span className={classes.key}>RTP: </span>
      <span className={classes.value}>{rtp.value || "N/A"}%</span>
    </InfoLabel>
  );
};

export default EngineInfo;
